// Permissions Reducer
const permissionsReducerDefaultState = []

export default (state = permissionsReducerDefaultState, action) => {
  switch (action.type) {
    case "SET_PERMISSIONS":
      return action.permissions

    case "ADD_PERMISSION":
      return [...state, action.permission]
    case "REMOVE_PERMISSION":
      return state.filter(({ id }) => id !== action.id)
    case "EDIT_PERMISSION":
      return state.map((permission) => {
        if (permission.id === action.id) {
          return {
            ...permission,
            ...action.updates,
          }
        } else {
          return permission
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/permissions.js